<template>
    <div class="login-page">
        
			<form ref="form" @submit.stop.prevent="handleSubmit">
				<span v-if="error_msg!=''" style="color: #ff4c5b;font-size: 15px;">{{error_msg}}</span>
                <b-form-group :state="userinfoState" label-for="mobile-input" invalid-feedback="Mobile or Email should be valid">
                    <b-form-input id="mobile-input" v-model="userinfo" :state="userinfoState" placeholder="Mobile or Email" @focusin="userinfoState = null"></b-form-input>
                </b-form-group>
                <b-form-group :state="passwordState"  label-for="password-input" invalid-feedback="Password should be greater than 4 digits">
                    <b-form-input type="password" id="password-input" v-model="password" :state="passwordState" placeholder="Password" @focusin="passwordState = null"></b-form-input>
                </b-form-group>
                <b-button type="submit" class="mr-2 btn-solid btn2 float-right" style="width:120px;" size="sm">Login</b-button>
				
				
				
				
				
                <!--<b-button type="reset" variant="light" @click="handleCancel()">Cancel</b-button> -->
                <!--<p class="my-2">
                    <b-link @click="showForgetPasswordModal()">Forget Password?</b-link>
                </p> -->
			</form>
		
    </div>
</template>

<script>
export default {
    name: 'Quickview',
    data() {
        return{
            url: this.$root.WEBURL+'customerlogin',
			myWalletrecordUrl: this.$root.WEBAPI+'walletapi/mywallet-record-login',
			myautoDebitMyAccountUrl: this.$root.WEBAPI+'walletapi/autoDebitMyAccount',
            userinfo: '',
            password: '',
            userinfoState: null,
            passwordState: null,
			error_msg:'',
        }
    },
    methods:{
        checkFormValidity() {
            var valid = true;
            if(this.userinfo.length < 10){
                valid = false;
                this.userinfoState = false;
            }else{
                this.userinfoState = true;
            }
            if(this.password.length < 4){
                valid = false;
                this.passwordState = false;
            }else{
                this.passwordState = true;
            }
            return valid;
        },
        resetModal(){
            this.userinfo = '';
            this.password = '';
            this.userinfoState = null;
            this.passwordState = null;
        },
        handleOk(bvModalEvt){
            bvModalEvt.preventDefault();
            this.handleSubmit();
        },
        handleCancel(){
            this.$bvModal.hide('login-modal');
        },
        handleSubmit(){
            if (!this.checkFormValidity()) {
                return;
            }

            var self = this;
            

            var o = {
                userinfo: this.userinfo,
                password: this.password
            }
            
			self.axios.post(self.url, o).then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvToast.toast(response.data.message, {
						title: 'Register',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'success',
						solid: true,
						appendToast: true
                    });
                    self.error_msg='';
                    self.$root.customer_info = response.data.result;
                    
                    self.$session.set('customer_info', self.$root.customer_info);
					self.$session.set('remindmelater',0);	
					var user_info = response.data.result;
					
					/* **************Wallet Data************************** */
					
					
					self.axios.post(self.myWalletrecordUrl, {
						accesskey: response.data.result.access_key
					})
					.then(function (responseW) {
						if(responseW.data.error == 0 || responseW.data.error == '0'){
							//console.log(responseW.data.result);
							var responcResult = response.data.result;
							
							responcResult['wallet'].blance = responseW.data.result.blance;
							responcResult['wallet'].cr_amount = responseW.data.result.cr_amount;
							responcResult['wallet'].dr_amount = responseW.data.result.dr_amount;
							responcResult['wallet'].cr_amount_cb = responseW.data.result.cr_amount_cb;
							responcResult['wallet'].dr_amount_cb = responseW.data.result.dr_amount_cb;
							responcResult['wallet'].blance_cb 	 = responseW.data.result.blance_cb;
							responcResult['wallet'].total_blance = responseW.data.result.total_blance;
							responcResult['wallet'].expiresdate = responseW.data.result.expiresdate;
							var expiresdate = responseW.data.result.expiresdate;
							//if(expiresdate<)
							
							//console.log(Date.now()+'----'+new Date(expiresdate));
							if(Date.now() > new Date(expiresdate)){
								//Do your thing;
									console.log('expiresdate');
									/* ================================= */
									if(user_info.role>1){
										if(responseW.data.result.blance>0){
											self.axios.post(self.myautoDebitMyAccountUrl, {
													accesskey: response.data.result.access_key,
													roleId:user_info.role,
													balance: responseW.data.result.blance,
												}).then(function (responseDe) {
														console.log(responseDe);
														responcResult['wallet'].blance = 0;
														self.$root.customer_info = responcResult;
														self.$session.set('customer_info', self.$root.customer_info);
													})
													.catch(function (error) {
														alert(error);
													});
										}
									}
									/* ================================= */
								
								
							} else {
								//console.log('Valid');
							}
							
							//var customer_info = self.$root.customer_info;							
							self.$root.customer_info = responcResult;
							self.$session.set('customer_info', self.$root.customer_info);
							self.$router.push('/checkout');
							//self.$router.go('/checkout');
							
						}else if(responseW.data.error == 9){
							self.$root.forceLogout(responseW.data.message);
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
					
					
					/* **************************************** */

					//self.$router.push('/checkout');
					self.$router.go('/checkout');
                   self.$bvModal.hide('login-modal');
				}else{
					self.error_msg = response.data.message;
				}
			})
			.catch(function (error) {
				alert(error);
			});
        },
        

        showForgetPasswordModal(){
            //this.$bvModal.hide('login-modal');
            this.$root.$emit('bv::show::modal', 'fp-modal')
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">


</style>
